export const LOCALES = ['de', 'en', 'es', 'fr', 'it'] as const;
export type LocaleCode = (typeof LOCALES)[number];

export function isSupportedLocale(v: string): v is LocaleCode {
  return (LOCALES as readonly string[]).includes(v as LocaleCode);
}
